import type { IService } from 'restangular'

import { app } from '../../app.module'

/**
 * イベントを新規作成、編集時に開くモーダル
 * attribute: {number} event-id 編集を行うイベントのイベントID
 */
class EditEventModalComponentCtrl {
  private scope: ng.IScope
  private rootScope: ng.IRootScopeService
  private Restangular: IService
  private mdDialog: {
    hide: Function
  }
  private DialogService: {
    showToast: Function
  }
  private eventId: number
  private valid: boolean
  private isLoading: boolean
  private eventData: {
    eventId: string | number
    date: number
    month: number
    eventName: string
    description: string
    tags: {
      tagId: number
    }[]
    tagIds?: [number]
  }

  constructor($scope, $rootScope, Restangular, $mdDialog, DialogService) {
    this.scope = $scope
    this.rootScope = $rootScope
    this.Restangular = Restangular
    this.mdDialog = $mdDialog
    this.DialogService = DialogService
    this.isLoading = false
    this.valid = false
  }

  /**
   * 初期化
   */
  public $onInit(): void {
    this.eventData = {
      eventId: this.eventId,
      month: null,
      date: null,
      eventName: null,
      description: null,
      tags: null,
    }

    // 編集の場合はデータをサーバーから取得してモーダルにセットする
    if (this.eventId !== undefined) {
      this.setEventData(this.eventId)
    } else {
      this.eventData.eventId = 'new'
    }

    // 子コンポーネントの変更をlistenする
    this.scope.$on('selectMonth', (event, month) => {
      this.scope.$broadcast('changeMonth', month)
      this.eventData.month = month
      this.validateForm()
    })
    this.scope.$on('selectDay', (event, date) => {
      this.eventData.date = date
      this.validateForm()
    })
    this.scope.$on('changeEventName', (event, eventName) => {
      this.eventData.eventName = eventName
      this.validateForm()
    })
    this.scope.$on('changeEventDescription', (event, description) => {
      this.eventData.description = description
      this.validateForm()
    })
    this.scope.$on('changeEventTagChips', (event, tags) => {
      this.eventData.tags = tags
      this.validateForm()
    })
  }

  /**
   * イベントを保存する
   */
  public saveEvent() {
    // 投稿タグのIDのみを抽出する
    this.eventData.tagIds = this.extractTagId(this.eventData.tags)

    // サーバーへPOSTし、toastを出してモーダルを閉じる
    this.Restangular.all(`/event/saveEvent`)
      .post(this.eventData)
      .then((result) => {
        if (result[0].error === null) {
          this.DialogService.showToast('イベントを保存しました', 'success-toast')
        } else {
          this.DialogService.showToast('イベントが保存できませんでした', 'error-toast')
        }
        // スコープが親と分離しているため、$rootScopeでイベントを送信
        this.rootScope.$broadcast('changeEventData')
        this.close()
      })
  }

  /**
   * イベントを削除する
   */
  public deleteEvent() {
    // confirmを出し、再確認する
    const answer = confirm(`${this.eventData.eventName}を削除してもよろしいですか？`)
    if (answer !== true) {
      return
    }

    const postData = {
      eventId: this.eventId,
    }

    // サーバーへPOSTし、toastを出してモーダルを閉じる
    this.Restangular.all(`/event/deleteEvent`)
      .post(postData)
      .then((result) => {
        if (result[0].error === null) {
          this.DialogService.showToast('イベントを削除しました', 'success-toast')
        } else {
          this.DialogService.showToast('イベントを削除できませんでした', 'error-toast')
        }
        this.rootScope.$broadcast('changeEventData')
        this.close()
      })
  }

  /**
   * モーダルを閉じる
   */
  public close() {
    this.mdDialog.hide()
  }

  /**
   * サーバーからイベントデータを取得し、子コンポーネントにデータを渡す
   * @param  {number} eventId イベントID
   */
  private setEventData(eventId: number) {
    this.isLoading = true
    this.Restangular.all(`/event/getEvent?event_id=${eventId}`)
      .getList()
      .then((result) => {
        const eventData = result[0].data[0]

        // 既存の投稿タグはJSON形式のstringなので、splitで分割し、JSONに変換する
        const splitedStrs = eventData.tags.split('\n')

        eventData.tags = splitedStrs.map((elem) => {
          return JSON.parse(elem)
        })

        this.eventData = eventData
        this.scope.$broadcast('setEventData', eventData)
        this.validateForm()
        this.isLoading = false
      })
  }

  /**
   * フォームに全てデータが入力されているかチェックする
   */
  private validateForm() {
    this.valid = true

    Object.keys(this.eventData).forEach((key) => {
      if (this.eventData[key] === '') {
        this.valid = false
      }
      if (this.eventData[key] === null) {
        this.valid = false
      }
      if (this.eventData[key] === undefined) {
        this.valid = false
      }
    })
  }

  /**
   * 投稿タグの配列から、タグのIDのみを抽出して返す
   * @param  [Array] tags タグの配列
   */
  private extractTagId(tags) {
    const result = tags.map((tag) => {
      return tag.tagId
    })

    return result
  }
}

app.component('editEventModal', {
  bindings: {
    eventId: '<',
  },
  template: require('./edit-event-modal.pug')(),
  controller: EditEventModalComponentCtrl,
})
